/** Canonical source type labels from Settings / Source Documents. */

export type SourceTypeRef = {
  id: number;
  name: string;
  isActive?: boolean;
};

export const buildSourceTypeById = (
  types: SourceTypeRef[] | null | undefined
): Record<number, { name: string }> => {
  const map: Record<number, { name: string }> = {};
  for (const type of types || []) {
    const id = Number(type?.id);
    const name = String(type?.name || '').trim();
    if (Number.isFinite(id) && id > 0 && name) {
      map[id] = { name };
    }
  }
  return map;
};

export const resolveFrameworkSourceTypeName = (
  framework: Record<string, unknown> | null | undefined,
  sourceTypeById?: Record<number, { name: string }>
): string => {
  if (!framework) return '';
  const typeId = Number(framework.sourceTypeId ?? framework.SourceTypeId);
  if (Number.isFinite(typeId) && typeId > 0) {
    const fromCatalog = sourceTypeById?.[typeId]?.name;
    if (fromCatalog) return fromCatalog;
  }
  return String(framework.frameworkType ?? framework.FrameworkType ?? '').trim();
};

export const getActiveSourceTypeNames = (types: SourceTypeRef[] | null | undefined): string[] =>
  (types || [])
    .filter((type) => type.isActive !== false && String(type.name || '').trim())
    .map((type) => String(type.name).trim())
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
